import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';
import { ReactComponent as ArrowUpIconSvg } from '../../../assets/icons/arrow-up.svg';

export default function ArrowUpIcon() {
  const theme = useTheme();
  return (
    <SvgIcon
      component={ArrowUpIconSvg}
      sx={{ '& path': { fill: 'white', stroke: theme.xPalette.shadeGrey } }}
    />
  );
}
